import React from 'react';
import { TFunction } from 'i18next';
import { ButtonGroup } from 'react-bootstrap';

type Props = {
	pageIndex: number;
	pageCount: number;
	previousPage: () => void;
	nextPage: () => void;
	getCanPreviousPage: () => boolean;
	getCanNextPage: () => boolean;
	t: TFunction;
};
const DashboardTableFooter = ({
	pageIndex,
	pageCount,
	previousPage,
	getCanPreviousPage,
	nextPage,
	getCanNextPage,
	t,
}: Props) =>
	pageCount > 1 ? (
		<div className="row">
			<div className="col-4 offset-4">
				{`${pageIndex + 1} ${t('table.of')} ${pageCount.toLocaleString()}`}
			</div>
			<div className="col-4">
				<ButtonGroup>
					<button
						className="btn btn-outline-primary"
						type="button"
						onClick={previousPage}
						disabled={!getCanPreviousPage()}>
						{t('table.previous')}
					</button>
					<button
						className="btn btn-outline-primary"
						type="button"
						onClick={nextPage}
						disabled={!getCanNextPage()}>
						{t('table.next')}
					</button>
				</ButtonGroup>
			</div>
		</div>
	) : null;

export default DashboardTableFooter;
